import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalManageRights from "./ModalManageRights";

const useModalManageRights = (onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, user_id: null, name: null })  ;

    const onClickActivate = (user_id, name) =>
    {
        setDialog ({ openState: true, user_id: user_id, name: name });
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, user_id: null, name: null, key: null });
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, user_id: null, name:null });
        // Tell the parent we're done
        onSaveCompleted( key ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                {< ModalManageRights user_id={dialog.user_id} name={dialog.name} onSaveCompleted={onSaveComplete} onClose={onCloseModal} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalManageRights ;
